import { render, staticRenderFns } from "./modal-schedule.vue?vue&type=template&id=5637cc35&scoped=true"
import script from "./modal-schedule.vue?vue&type=script&lang=js"
export * from "./modal-schedule.vue?vue&type=script&lang=js"
import style0 from "./modal-schedule.vue?vue&type=style&index=0&id=5637cc35&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5637cc35",
  null
  
)

export default component.exports